import {
  ArrowsCounterClockwise,
  Buildings,
  Car,
  CheckSquare,
  ClockCounterClockwise,
  CrosshairSimple,
  CurrencyEur,
  CurrencyCircleDollar,
  Files,
  FolderOpen,
  FileText,
  GearSix,
  // House, // Commented out with Dashboard
  Images,
  Info,
  ListChecks,
  ListBullets as ListBulletsIcon,
  Kanban as KanbanIcon,
  MapTrifold,
  Notepad,
  SelectionAll,
  StackSimple,
  Tag,
  CalendarBlank,
  Tray,
  Umbrella,
  UsersThree,
  WhatsappLogo,
  Plus,
  ChartBar,
  ChartLineUp,
  BookOpen,
  Briefcase,
  Scales,
  ShieldCheck,
  Package,
  Sparkle,
  Bug,
  RocketLaunch,
  BulldozerIcon,
  WrenchIcon,
  SirenIcon,
  WallIcon,
  Tree,
  Fire,
  ThermometerHot,
  Wallet,
  LockKey,
  TreeStructure,
} from "@phosphor-icons/react";

export interface RouteItem {
  to: string;
  label: string;
  icon: JSX.Element;
  permission?: string;
  children?: RouteItem[];
  showInNav?: boolean; // Whether to show in navigation (defaults to true)
  showParentInSubmenu?: boolean; // Whether to show parent route in submenu (defaults to true)
}

export interface RouteCategory {
  label: string;
  icon: JSX.Element;
  routes: RouteItem[];
  showInNav?: boolean;
}

// Keep the old flat structure for backward compatibility
export const routesConfig: RouteItem[] = [
  // {
  //   to: "/",
  //   label: "Dashboard",
  //   icon: <House weight="duotone" size={20} />,
  //   permission: "canAccessDashboard",
  // },
  {
    to: "/contacts",
    label: "Contacten",
    icon: <UsersThree weight="duotone" size={20} />,
    permission: "canAccessContacts",
    children: [
      {
        to: "/contact/new",
        label: "Nieuw Contact",
        icon: <Plus weight="duotone" size={16} />,
        permission: "canAccessContacts",
      },
    ],
  },
  {
    to: "/acquisitions",
    label: "Acquisities",
    icon: <CrosshairSimple weight="duotone" size={20} />,
    permission: "canAccessAcquisitions",
  },
  {
    to: "/acquisitions/statistics",
    label: "Statistieken",
    icon: <ChartBar weight="duotone" size={20} />,
    permission: "canAccessAcquisitions",
  },
  {
    to: "/due-diligence",
    label: "Due diligence",
    icon: <ListChecks weight="duotone" size={20} />,
    permission: "canAccessDueDiligence",
  },
  {
    to: "/pictures",
    label: "Foto's",
    icon: <Images weight="duotone" size={20} />,
    permission: "canAccessPictures",
  },
  {
    to: "/documents",
    label: "Documenten",
    icon: <Files weight="duotone" size={20} />,
    permission: "canAccessDocuments",
  },
  {
    to: "/clusters",
    label: "Clusters",
    icon: <MapTrifold weight="duotone" size={20} />,
    permission: "canAccessClusters",
    children: [
      {
        to: "/clusters/new",
        label: "Nieuwe Cluster",
        icon: <Plus weight="duotone" size={16} />,
        permission: "canAccessClusters",
      },
    ],
  },
  {
    to: "/segments",
    label: "Segmenten",
    icon: <TreeStructure weight="duotone" size={20} />,
    permission: "canAccessClusters",
  },
  {
    to: "/buildings",
    label: "Gebouwen",
    icon: <Buildings weight="duotone" size={20} />,
    permission: "canAccessBuildings",
  },
  {
    to: "/units",
    label: "Units",
    icon: <StackSimple weight="duotone" size={20} />,
    permission: "canAccessUnits",
  },
  {
    to: "/building-attributes",
    label: "Gebouw attributen",
    icon: <Car weight="duotone" size={20} />,
    permission: "canAccessBuildingAttributes",
  },
  {
    to: "/rental",
    label: "Verhuur",
    icon: <ArrowsCounterClockwise weight="duotone" size={20} />,
    permission: "canAccessRental",
  },
  {
    to: "/rental/indexaties",
    label: "Indexaties",
    icon: <ChartLineUp weight="duotone" size={20} />,
    permission: "canAccessRental",
  },
  {
    to: "/rental/candidacies",
    label: "Kandidaten",
    icon: <UsersThree weight="duotone" size={20} />,
    permission: "canAccessRental",
  },
  {
    to: "/rental/herverhuur",
    label: "Herverhuur",
    icon: <ArrowsCounterClockwise weight="duotone" size={20} />,
    permission: "canAccessRental",
  },
  {
    to: "/helpdesk",
    label: "Helpdesk",
    icon: <SirenIcon weight="duotone" size={20} />,
    permission: "canAccessHelpdesk",
    showParentInSubmenu: false, // Don't show "Helpdesk" in submenu
    children: [
      {
        to: "/helpdesk/list",
        label: "Lijst weergave",
        icon: <ListBulletsIcon weight="duotone" size={16} />,
        permission: "canAccessHelpdesk",
      },
      {
        to: "/helpdesk/kanban",
        label: "Kanban weergave",
        icon: <KanbanIcon weight="duotone" size={16} />,
        permission: "canAccessHelpdesk",
      },
      {
        to: "/helpdesk/statistics",
        label: "Statistieken",
        icon: <ChartBar weight="duotone" size={16} />,
        permission: "canAccessHelpdesk",
      },
      {
        to: "/helpdesk/new",
        label: "Nieuw Ticket",
        icon: <Plus weight="duotone" size={16} />,
        permission: "canAccessHelpdesk",
      },
    ],
  },
  {
    to: "/conversations",
    label: "Conversaties",
    icon: <WhatsappLogo weight="duotone" size={20} />,
    permission: "canAccessConversations",
  },
  {
    to: "/maintenance/statistieken",
    label: "Onderhoud",
    icon: <WrenchIcon weight="duotone" size={20} />,
    permission: "canAccessMaintenance",
  },
  {
    to: "/insurances",
    label: "Verzekeringen",
    icon: <Umbrella weight="duotone" size={20} />,
    permission: "canAccessInsurance",
  },
  {
    to: "/renovation",
    label: "Renovatie",
    icon: <WallIcon weight="duotone" size={20} />,
    permission: "canAccessRenovation",
    children: [
      {
        to: "/renovation/investments",
        label: "Investeringslijnen",
        icon: <Wallet weight="duotone" size={16} />,
        permission: "canAccessRenovation",
      },
      {
        to: "/renovation/projects?new=1",
        label: "Nieuw Project",
        icon: <Plus weight="duotone" size={16} />,
        permission: "canAccessRenovation",
      },
      // {
      //   to: "/renovation/budgets",
      //   label: "Budgetten",
      //   icon: <CurrencyEur weight="duotone" size={16} />,
      //   permission: "canAccessRenovation",
      // },
      {
        to: "/renovation/documents",
        label: "Financiële documenten",
        icon: <FileText weight="duotone" size={16} />,
        permission: "canAccessRenovation",
      },
    ],
  },
  {
    to: "/tasks",
    label: "Taken",
    icon: <CheckSquare weight="duotone" size={20} />,
    permission: "canAccessTasks",
  },
  {
    to: "/notes",
    label: "Notities",
    icon: <Notepad weight="duotone" size={20} />,
    permission: "canAccessNotes",
  },
  {
    to: "/settings",
    label: "Instellingen",
    icon: <GearSix weight="duotone" size={20} />,
    permission: "canAccessSettings",
  },
  {
    to: "/entity-schema/:entityName",
    label: "Entity Schema Visualisatie",
    icon: <Tree weight="duotone" size={20} />,
    permission: "canAccessSettings",
    showInNav: false, // Hidden route - accessed via tree button in settings
  },
];

// New categorized navigation structure
export const categorizedRoutesConfig: RouteCategory[] = [
  {
    label: "Acquisities",
    icon: <CrosshairSimple weight="duotone" size={20} />,
    routes: [
      {
        to: "/acquisitions",
        label: "Acquisities",
        icon: <CrosshairSimple weight="duotone" size={20} />,
        permission: "canAccessAcquisitions",
      },
      {
        to: "/acquisitions/statistics",
        label: "Statistieken",
        icon: <ChartBar weight="duotone" size={20} />,
        permission: "canAccessAcquisitions",
      },
      {
        to: "/due-diligence",
        label: "Due diligence",
        icon: <ListChecks weight="duotone" size={20} />,
        permission: "canAccessDueDiligence",
      },
    ],
  },
  {
    label: "Vastgoed",
    icon: <Buildings weight="duotone" size={20} />,
    routes: [
      {
        to: "/clusters",
        label: "Clusters",
        icon: <MapTrifold weight="duotone" size={20} />,
        permission: "canAccessClusters",
      },
      {
        to: "/segments",
        label: "Segmenten",
        icon: <TreeStructure weight="duotone" size={20} />,
        permission: "canAccessClusters",
      },
      {
        to: "/buildings",
        label: "Gebouwen",
        icon: <Buildings weight="duotone" size={20} />,
        permission: "canAccessBuildings",
      },
      {
        to: "/units",
        label: "Units",
        icon: <StackSimple weight="duotone" size={20} />,
        permission: "canAccessUnits",
      },
      {
        to: "/building-attributes",
        label: "Attributen",
        icon: <Car weight="duotone" size={20} />,
        permission: "canAccessBuildingAttributes",
      },
      {
        to: "/assets",
        label: "Voorzieningen",
        icon: <Package weight="duotone" size={20} />,
        permission: "canAccessBuildings",
      },
      {
        to: "/accesscontrol",
        label: "Toegangscontrole",
        icon: <LockKey weight="duotone" size={20} />,
        permission: "canAccessBuildings",
      },
    ],
  },
  {
    label: "Gebouw Details",
    icon: <Buildings weight="duotone" size={20} />,
    showInNav: false, // Don't show in main nav
    routes: [
      {
        to: "/building/:id",
        label: "Gebouw",
        icon: <Buildings weight="duotone" size={20} />,
        permission: "canAccessBuildings",
        showParentInSubmenu: false, // Don't show parent in submenu, just the children
        children: [
          {
            to: "/building/:id",
            label: "Gegevens",
            icon: <Info weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/units",
            label: "Units",
            icon: <StackSimple weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/verhuur",
            label: "Verhuur",
            icon: <ArrowsCounterClockwise weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/financieel",
            label: "Financieel",
            icon: <CurrencyEur weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/due-diligence",
            label: "Due Diligence (Oud)",
            icon: <ListChecks weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/due-diligence-nieuw",
            label: "Due Diligence (Nieuw)",
            icon: <ListChecks weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/onderhoud",
            label: "Onderhoud",
            icon: <ArrowsCounterClockwise weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/renovatie",
            label: "Renovatie",
            icon: <WallIcon weight="duotone" size={16} />,
            permission: "canAccessRenovation",
          },
          {
            to: "/building/:id/bouwschil",
            label: "Bouwschil",
            icon: <SelectionAll weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/contacts",
            label: "Contacten",
            icon: <UsersThree weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/attributen",
            label: "Attributen",
            icon: <Tag weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/plattegrond",
            label: "Plattegrond",
            icon: <MapTrifold weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/investeringen",
            label: "Investeringen",
            icon: <Wallet weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/voorzieningen",
            label: "Voorzieningen",
            icon: <Package weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/historiek",
            label: "Historiek",
            icon: <ClockCounterClockwise weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/dropzone",
            label: "Dropzone",
            icon: <Tray weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
          {
            to: "/building/:id/mappenstructuur",
            label: "Mappenstructuur",
            icon: <FolderOpen weight="duotone" size={16} />,
            permission: "canAccessBuildings",
          },
        ],
      },
    ],
  },
  {
    label: "Renovatie",
    icon: <WallIcon weight="duotone" size={20} />,
    routes: [
      {
        to: "/renovation",
        label: "Overzicht",
        icon: <BulldozerIcon weight="duotone" size={16} />,
        permission: "canAccessRenovation",
      },
      {
        to: "/renovation/investments",
        label: "Investeringslijnen",
        icon: <Wallet weight="duotone" size={16} />,
        permission: "canAccessRenovation",
      },
      {
        to: "/renovation/projects",
        label: "Projecten",
        icon: <WallIcon weight="duotone" size={16} />,
        permission: "canAccessRenovation",
      },
      {
        to: "/renovation/projects?new=1",
        label: "Nieuw Project",
        icon: <Plus weight="duotone" size={16} />,
        permission: "canAccessRenovation",
      },
      // {
      //   to: "/renovation/budgets",
      //   label: "Budgetten",
      //   icon: <CurrencyEur weight="duotone" size={16} />,
      //   permission: "canAccessRenovation",
      // },
      {
        to: "/renovation/documents",
        label: "Financiële documenten",
        icon: <FileText weight="duotone" size={16} />,
        permission: "canAccessRenovation",
      },
      {
        to: "/renovation/energieprestaties",
        label: "Energieprestaties",
        icon: <ChartLineUp weight="duotone" size={16} />,
        permission: "canAccessRenovation",
      },
      {
        to: "/renotickets",
        label: "Renovatietickets",
        icon: <WrenchIcon weight="duotone" size={16} />,
        permission: "canAccessRenovation",
      },
    ],
  },
  {
    label: "Verhuur",
    icon: <ArrowsCounterClockwise weight="duotone" size={20} />,
    routes: [
      {
        to: "/rental/herverhuur",
        label: "Herverhuur",
        icon: <ArrowsCounterClockwise weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/vacancies",
        label: "Leegstand",
        icon: <Buildings weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/candidacies",
        label: "Kandidaten",
        icon: <UsersThree weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/incasso",
        label: "Incasso",
        icon: <Files weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/indexaties",
        label: "Indexaties",
        icon: <ChartLineUp weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/watchlist",
        label: "Watchlist",
        icon: <ListChecks weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/missing-documents",
        label: "Ontbrekende documenten",
        icon: <Files weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/statistics",
        label: "Statistieken",
        icon: <ChartLineUp weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/milestones",
        label: "Belangrijke gebeurtenissen",
        icon: <CheckSquare weight="duotone" size={16} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/all-contracts",
        label: "Alle contracten",
        icon: <FileText weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/value-creation",
        label: "Waardecreatie",
        icon: <ChartBar weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/contracts-this-year",
        label: "Contracten dit jaar",
        icon: <ArrowsCounterClockwise weight="duotone" size={16} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/incoming-tenants",
        label: "Ingaande huurders",
        icon: <UsersThree weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
      {
        to: "/rental/outgoing-tenants",
        label: "Uitgaande huurders",
        icon: <UsersThree weight="duotone" size={20} />,
        permission: "canAccessRental",
      },
    ],
  },
  {
    label: "Helpdesk",
    icon: <SirenIcon weight="duotone" size={20} />,
    routes: [
      {
        to: "/helpdesk/list",
        label: "Lijst weergave",
        icon: <ListBulletsIcon weight="duotone" size={20} />,
        permission: "canAccessHelpdesk",
      },
      {
        to: "/helpdesk/kanban",
        label: "Kanban weergave",
        icon: <KanbanIcon weight="duotone" size={20} />,
        permission: "canAccessHelpdesk",
      },
      {
        to: "/helpdesk/statistics",
        label: "Statistieken",
        icon: <ChartBar weight="duotone" size={20} />,
        permission: "canAccessHelpdesk",
      },
      {
        to: "/helpdesk/opex-invoices",
        label: "Facturen OPEX",
        icon: <FileText weight="duotone" size={20} />,
        permission: "canAccessHelpdesk",
      },
      {
        to: "/conversations",
        label: "WhatsApp",
        icon: <WhatsappLogo weight="duotone" size={20} />,
        permission: "canAccessConversations",
      },
      {
        to: "/helpdesk/new",
        label: "Nieuw Ticket",
        icon: <Plus weight="duotone" size={16} />,
        permission: "canAccessHelpdesk",
      },
    ],
  },
  {
    label: "Onderhoud",
    icon: <WrenchIcon weight="duotone" size={20} />,
    routes: [
      // Static maintenance pages (Statistieken + Onderhoudsplanning removed — available via Voorzieningen tabs)
      // Dynamic category pages injected by navMenu.tsx from asset categories with slugs
      {
        to: "/maintenance/brandveiligheid",
        label: "Brandveiligheid",
        icon: <Fire weight="duotone" size={20} />,
        permission: "canAccessMaintenance",
      },
      {
        to: "/maintenance/klimatisatie",
        label: "Klimatisatie",
        icon: <ThermometerHot weight="duotone" size={20} />,
        permission: "canAccessMaintenance",
      },
      // Energieprestaties moved to Renovatie menu (2026-05-12); redirect in clerkProviderWithRoutes.tsx
    ],
  },
  {
    label: "Contacten",
    icon: <UsersThree weight="duotone" size={20} />,
    routes: [
      {
        to: "/contacts",
        label: "Contacten",
        icon: <UsersThree weight="duotone" size={20} />,
        permission: "canAccessContacts",
        children: [
          {
            to: "/contact/new",
            label: "Nieuw Contact",
            icon: <Plus weight="duotone" size={16} />,
            permission: "canAccessContacts",
          },
          {
            to: "/company/new",
            label: "Nieuw Bedrijf",
            icon: <Briefcase weight="duotone" size={16} />,
            permission: "canAccessContacts",
          },
        ],
      },
      {
        to: "/contacts/gebouwcontacten",
        label: "Gebouwcontacten",
        icon: <Buildings weight="duotone" size={20} />,
        permission: "canAccessContacts",
      },
    ],
  },
  {
    label: "Bestanden",
    icon: <Files weight="duotone" size={20} />,
    routes: [
      {
        to: "/documents",
        label: "Documenten",
        icon: <Files weight="duotone" size={20} />,
        permission: "canAccessDocuments",
      },
      {
        to: "/document-generator",
        label: "Document Generator",
        icon: <FileText weight="duotone" size={20} />,
        permission: "canAccessDocuments", // Using same permission as documents for now
      },
      {
        to: "/draaiboeken",
        label: "Draaiboeken",
        icon: <BookOpen weight="duotone" size={20} />,
        permission: "canAccessDocuments", // Using same permission as documents for now
      },
      {
        to: "/pictures",
        label: "Foto's",
        icon: <Images weight="duotone" size={20} />,
        permission: "canAccessPictures",
      },
    ],
  },
  {
    label: "Productiviteit",
    icon: <CheckSquare weight="duotone" size={20} />,
    routes: [
      {
        to: "/tasks",
        label: "Taken",
        icon: <CheckSquare weight="duotone" size={20} />,
        permission: "canAccessTasks",
      },
      {
        to: "/notes",
        label: "Notities",
        icon: <Notepad weight="duotone" size={20} />,
        permission: "canAccessNotes",
      },
      {
        to: "/ella",
        label: "Ella - AI Assistent",
        icon: <Sparkle weight="duotone" size={20} />,
        permission: "canAccessSettings", // Everyone can access Ella for now
      },
    ],
  },
  {
    label: "Corporate",
    icon: <Briefcase weight="duotone" size={20} />,
    routes: [
      {
        to: "/vennootschappen",
        label: "Vennootschappen",
        icon: <Briefcase weight="duotone" size={20} />,
        // Allow both General (read-only) and Corporate (full access) users
        permission: "canAccessGeneral", // Will show for both since route guard handles dual access
      },
      {
        to: "/financials-gebouwen",
        label: "Financials Gebouwen",
        icon: <CurrencyEur weight="duotone" size={20} />,
        permission: "canAccessCorporate",
      },
      {
        to: "/insurances",
        label: "Verzekeringen",
        icon: <Umbrella weight="duotone" size={20} />,
        permission: "canAccessInsurance",
      },
      {
        to: "/litigations",
        label: "Litigations",
        icon: <Scales weight="duotone" size={20} />,
        permission: "canAccessCorporate", // Future: canAccessLitigations
      },
      {
        to: "/corporate-verplichtingen",
        label: "Corporate verplichtingen",
        icon: <FileText weight="duotone" size={20} />,
        permission: "canAccessCorporate", // Future: canAccessCorporateObligations
      },
      {
        to: "/gdpr",
        label: "GDPR",
        icon: <ShieldCheck weight="duotone" size={20} />,
        permission: "canAccessCorporate", // Future: canAccessGDPR
      },
      {
        to: "/company-equipment",
        label: "Bedrijfsuitrusting",
        icon: <Package weight="duotone" size={20} />,
        permission: "canAccessCorporate",
      },
    ],
  },
];

// Standalone routes (not in categories)
export const standaloneRoutes: RouteItem[] = [
  {
    to: "/agenda",
    label: "Agenda",
    icon: <CalendarBlank weight="duotone" size={20} />,
  },
  {
    to: "/bug-reports",
    label: "Product",
    icon: <Bug weight="duotone" size={20} />,
    permission: "canAccessGeneral",
    showParentInSubmenu: false, // Don't show parent in submenu, just the children
    children: [
      {
        to: "/bug-reports",
        label: "Bugs & Suggesties",
        icon: <Bug weight="duotone" size={16} />,
        permission: "canAccessGeneral",
      },
      {
        to: "/bug-reports/epics",
        label: "Roadmap",
        icon: <RocketLaunch weight="duotone" size={16} />,
        permission: "canAccessGeneral",
      },
      {
        to: "/pricing-simulator",
        label: "Prijssimulator",
        icon: <CurrencyCircleDollar weight="duotone" size={16} />,
        permission: "canAccessGeneral",
      },
    ],
  },
  {
    to: "/settings",
    label: "Instellingen",
    icon: <GearSix weight="duotone" size={20} />,
    permission: "canAccessSettings",
  },
];

// Helper function to get all routes (flattened)
export const getAllRoutes = (): RouteItem[] => {
  const flatten = (routes: RouteItem[]): RouteItem[] => {
    return routes.reduce((acc: RouteItem[], route) => {
      acc.push(route);
      if (route.children) {
        acc.push(...flatten(route.children));
      }
      return acc;
    }, []);
  };

  return flatten(routesConfig);
};

// Helper function to get only top-level routes (for backward compatibility)
export const getTopLevelRoutes = (): RouteItem[] => {
  return routesConfig.filter((route) => route.showInNav !== false);
};

// Helper function to find a route by path
export const findRouteByPath = (path: string): RouteItem | undefined => {
  const allRoutes = getAllRoutes();
  return allRoutes.find((route) => route.to === path);
};
